import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const neighborhoods = [
  { name: "Brickell", slug: "brickell" },
  { name: "Aventura", slug: "aventura" },
  { name: "Miami Beach", slug: "miami-beach" },
  { name: "Coral Gables", slug: "coral-gables" },
  { name: "Coconut Grove", slug: "coconut-grove" },
  { name: "Doral", slug: "doral" },
  { name: "Kendall", slug: "kendall" },
  { name: "Pinecrest", slug: "pinecrest" },
  { name: "Bay Harbor Islands", slug: "bay-harbor-islands" },
  { name: "Key Biscayne", slug: "key-biscayne" },
  { name: "South Miami", slug: "south-miami" },
  { name: "North Miami Beach", slug: "north-miami-beach" },
];

interface Props {
  serviceName: string;
  serviceSlug: string;
  heading?: string;
}

export default function ServiceAreasGrid({ serviceName, serviceSlug, heading }: Props) {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-white py-16 md:py-20">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-[28px] font-bold text-[#064e3b] text-center mb-10">
          {heading || `${serviceName} ${t("common.areasInTheseAreas")}`}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {neighborhoods.map((n) => (
            <Link
              key={n.slug}
              to={`/impact-windows-${n.slug}/`}
              className="flex items-center justify-center px-3 py-2.5 bg-white text-[#064e3b] text-xs md:text-sm font-medium rounded-lg border border-[#064e3b]/15 hover:bg-[#064e3b] hover:text-white transition-colors whitespace-nowrap"
            >
              {serviceName} {n.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}